export default "__VITE_ASSET__c3bc2e7c__"